import { MasterListData } from "../types/List";
import { userApiUrl } from "./api";

const API_URL = "/MasterListDetails";

export const getData = async (): Promise<MasterListData[]> => {
  try {
    const res = await userApiUrl.get<MasterListData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get master list details error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const getDataById = async (
  id: number
): Promise<MasterListData | null> => {
  try {
    const res = await userApiUrl.get<MasterListData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get master list detail error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};
